import { ClientConfig, clientConfigSchema } from "@/types";
import { validateWithSchema } from "@/utils/dataValidators.zod";
import localforage from "localforage";

export async function clearAllLocFor(): Promise<void> {
  await localforage.clear();
}

export async function locForSetClientConfig(
  clientConfig: ClientConfig
): Promise<void> {
  await localforage.setItem("client-config", clientConfig);
}

export async function locForGetClientConfig(): Promise<ClientConfig | null> {
  const localforageData = await localforage.getItem("client-config");
  if (!localforageData) {
    return null;
  }

  const validatedData = validateWithSchema<ClientConfig>(
    localforageData,
    clientConfigSchema,
    "ClientConfig"
  );

  if (validatedData) {
    return validatedData;
  }

  console.error(
    "locForGetClientConfig: Invalid client config",
    localforageData
  );
  await clearAllLocFor();
  window.location.reload();
  return null;
}
